import { api } from 'services/api';
import React, { useState, useEffect } from 'react';

import { session } from 'services/session';

import { Loader } from 'components/misc/loader-utils';

import './collections.scss';

const mockResponse = () => {
	return {
	};
};

// Table Column Headers
const columnHeaders = ['Status', 'Collection Title', 'Collection Type', 'Merchants', 'Products'];

const Collections = () => {
	const [didMount, setDidMount] = useState(false);
	const [loading, setLoading] = useState(true);
	const [mockData, setMockData] = useState(false);
	const [collections, setCollections] = useState(null);
	const [params, setParams] = useState(null);

	useEffect(() => {
		setDidMount(true);
	}, []);

	// TODO: set params
	useEffect(() => {
		setParams((prevState) => {
			return {
				...prevState,
			};
		});
	}, []);

	useEffect(() => {
		if (didMount) {
			setLoading(true);
			getTableData();
		}
	}, [params, mockData]);

	// TODO: set endpoint
	function getTableData() {
		if (mockData) {
			const mockResponseData = mockResponse();
			setCollections(mockResponseData);
			setLoading(false);
		} else {
			api.get('', params).then((collections) => {
				setCollections(collections);
				setLoading(false);
			}).catch(() => {
				setCollections({});
				setLoading(false);
			});
		}
	}

	function getDisplayTxt() {
		if (loading) return <h1>-</h1>;

		const dataLen = collections.length;

		const displayTxt = !dataLen ? 'No' : dataLen === 1
			? 'Displaying 1'
			: `Displaying ${dataLen}`;

		return (
			<h1>{`${displayTxt} Collections`}</h1>
		);
	}

	const mocksButton = session.isAdminView ? (
		<button onClick={() => setMockData(!mockData)}>Mocks</button>
	) : null;

	return (
		<div className="collections-container">
			<Loader loading={loading} />
			<h1>Collections</h1>

			<div className="search-bar">
				{/* TODO: Search Bar */}
			</div>

			<div className="header">
				<div className="toggles">
					{getDisplayTxt()}
					{mocksButton}
				</div>

				<div className="filters">
					<div className="row">
						{/* TODO: Dropdowns */}
					</div>
				</div>
			</div>

			{/* OverviewTable */}
		</div>
	);
};

export default Collections;
